import React from "react";

import { Box, Button, Typography, useTheme,Grid } from "@material-ui/core";

import pdfIcon from "../../../Images/pdfIcon.svg";

function DocCard(props) {
  const { title, link } = props;

  const theme = useTheme();

  return (
    <div>
      <Box display="flex" alignItems="center" mb="16px">
      <Grid
                     
                      container
                      direction="row"
                      spacing={2}
                      alignItem="center"
                    >
                      <Grid item xs={1}>
        <img
          src={pdfIcon}
          alt="pdf-icon"
          style={{ height: "20px", marginRight: 20 }}
        /></Grid>
          <Grid item xs={8}>
        <Typography variant="body1" style={{ fontSize: 14, marginRight: 43 }}>
          {title}
        </Typography></Grid>
        <Grid item xs={1}>   <Button   
          disableElevation
          style={{
            width: "67px",
            height: "28px",
            borderRadius: 5,
            backgroundColor: "#3B86FF1A",
            color: "#3B86FF",
            textTransform: "capitalize",
          }}
          variant="contained"
          onClick={() => window.open(link)}
        >
          View
        </Button></Grid></Grid>
      </Box>
    </div>
  );
}

export default DocCard;
